import { COMPONENT_TYPES } from '../../../constants';
import RecommendedUsersComponent from './RecommendedUsers.component';
import RecommendedUsersEditor from './RecommendedUsers.editor';
import RecommendedUsersProperties from './RecommendedUsers.properties';
import { registerComponent } from '../registry';

// 컴포넌트 타입 상수
export const COMPONENT_TYPE = 'RECOMMENDED_USERS';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.RECOMMENDED_USERS,
  component: RecommendedUsersComponent,
  editorComponent: RecommendedUsersEditor,
  properties: RecommendedUsersProperties,
  defaultProps: {
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Noto Sans KR, sans-serif',
      maxWidth: '800px',
      margin: '20px auto',
      position: 'relative'
    },
    componentProps: {
      title: '피추천인 목록',
      emptyText: '데이터가 없습니다',
      loadingText: '로딩 중...',
      loginRequiredText: '로그인이 필요합니다.'
    }
  },
  category: 'advanced', // 고급 컴포넌트 카테고리
  icon: '👥', // 대표 아이콘 (사용자 아이콘)
  name: '추천 사용자' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as RecommendedUsersComponent } from './RecommendedUsers.component';
export { default as RecommendedUsersEditor } from './RecommendedUsers.editor';
export { default as RecommendedUsersProperties } from './RecommendedUsers.properties';
export * from './RecommendedUsers.types'; 